import request from './request'
import { WORK_URL, WORK_TASK_QUERY_URL, WORK_UPLOAD_URL, WORK_SIGN_URL, WORK_PUSH_URL } from './config'

export function createShortNovelByText (payload) {
  return request.post(WORK_URL, payload)
}

export function uploadShortNovelFile (formData, config) {
  return request.post(WORK_UPLOAD_URL, formData, config)
}

export function queryShortNovelTask (taskId) {
  return request.post(WORK_TASK_QUERY_URL, { taskId })
}

export function signShortNovel (payload) {
  return request.post(WORK_SIGN_URL, payload)
}

export function pushShortNovel (payload) {
  return request.post(WORK_PUSH_URL, payload)
}

